let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("etyIS")).then(() => parcelRequire('4aWzA'));